// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}
.modal-content .modal-header {
  border-bottom: 1px solid #e4e6ef;
  padding: 20px 24px;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-content .modal-header .modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #181c32;
  margin: 0;
}
.modal-content .modal-header .btn {
  padding: 0;
  margin: 0;
  opacity: 0.5;
  font-size: 24px;
  line-height: 1;
  border: none;
  background: transparent;
  cursor: pointer;
}
.modal-content .modal-header .btn:hover {
  opacity: 1;
}
.modal-content .modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}
.modal-content .modal-body .version-number h3 {
  font-size: 24px;
  font-weight: 700;
  color: #181c32;
  margin: 0;
}
.modal-content .modal-body .section .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #181c32;
  margin-bottom: 16px;
}
.modal-content .modal-body .section .section-content {
  font-size: 14px;
  color: #5e6278;
  line-height: 1.6;
  margin: 0;
}
.modal-content .modal-body .section .info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 768px) {
  .modal-content .modal-body .section .info-grid {
    grid-template-columns: 1fr;
  }
}
.modal-content .modal-body .section .info-grid .info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.modal-content .modal-body .section .info-grid .info-item .info-label {
  font-size: 13px;
  font-weight: 600;
  color: #7e8299;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.modal-content .modal-body .section .info-grid .info-item .info-value {
  font-size: 14px;
  color: #181c32;
  font-weight: 500;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  width: -moz-fit-content;
  width: fit-content;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge.status-completed {
  background-color: #50cd89;
  color: #fff;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge.status-in-progress {
  background-color: #ffc700;
  color: #fff;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge.status-planned {
  background-color: #009ef7;
  color: #fff;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge.status-archived {
  background-color: #a1a5b7;
  color: #fff;
}
.modal-content .modal-body .section .info-grid .info-item .status-badge.status-default {
  background-color: #f1f1f2;
  color: #5e6278;
}
.modal-content .modal-body .section .features-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal-content .modal-body .section .features-list .feature-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 8px;
}
.modal-content .modal-body .section .features-list .feature-item .feature-number {
  font-size: 14px;
  font-weight: 600;
  color: #181c32;
  min-width: 24px;
}
.modal-content .modal-body .section .features-list .feature-item .feature-content {
  flex: 1;
}
.modal-content .modal-body .section .features-list .feature-item .feature-content .feature-name {
  font-size: 14px;
  font-weight: 600;
  color: #181c32;
  margin-bottom: 4px;
}
.modal-content .modal-body .section .features-list .feature-item .feature-content .feature-description {
  font-size: 13px;
  color: #5e6278;
  line-height: 1.5;
}
.modal-content .modal-body .section .no-features {
  font-size: 14px;
  color: #7e8299;
  font-style: italic;
}
.modal-content .modal-footer {
  border-top: 1px solid #e4e6ef;
  padding: 16px 24px;
  background-color: #f9f9f9;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: flex-end;
}
.modal-content .modal-footer .btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  border: none;
  cursor: pointer;
}
.modal-content .modal-footer .btn.btn-light {
  background-color: #f1f1f2;
  border-color: #f1f1f2;
  color: #5e6278;
}
.modal-content .modal-footer .btn.btn-light:hover {
  background-color: #e4e6ef;
  border-color: #e4e6ef;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/version-details-modal/version-details-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,2CAAA;AACF;AACE;EACE,gCAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AACN;AAEI;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AAAN;AAEM;EACE,UAAA;AAAR;AAKE;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAMM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAJR;AASM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAPR;AAUM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AARR;AAWM;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AATR;AAWQ;EALF;IAMI,0BAAA;EARR;AACF;AAUQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARV;AAUU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AARZ;AAWU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AATZ;AAYU;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;AAVZ;AAYY;EACE,yBAAA;EACA,WAAA;AAVd;AAaY;EACE,yBAAA;EACA,WAAA;AAXd;AAcY;EACE,yBAAA;EACA,WAAA;AAZd;AAeY;EACE,yBAAA;EACA,WAAA;AAbd;AAgBY;EACE,yBAAA;EACA,cAAA;AAdd;AAoBM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBR;AAoBQ;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAlBZ;AAqBU;EACE,OAAA;AAnBZ;AAqBY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAnBd;AAsBY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AApBd;AA0BM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAxBR;AA6BE;EACE,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,yBAAA;AA3BJ;AA6BI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA3BN;AA6BM;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AA3BR;AA6BQ;EACE,yBAAA;EACA,qBAAA;AA3BV","sourcesContent":[".modal-content {\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n\n  .modal-header {\n    border-bottom: 1px solid #e4e6ef;\n    padding: 20px 24px;\n    background-color: #fff;\n    border-radius: 12px 12px 0 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .modal-title {\n      font-size: 20px;\n      font-weight: 600;\n      color: #181c32;\n      margin: 0;\n    }\n\n    .btn {\n      padding: 0;\n      margin: 0;\n      opacity: 0.5;\n      font-size: 24px;\n      line-height: 1;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 24px;\n    max-height: 70vh;\n    overflow-y: auto;\n\n    .version-number {\n      h3 {\n        font-size: 24px;\n        font-weight: 700;\n        color: #181c32;\n        margin: 0;\n      }\n    }\n\n    .section {\n      .section-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #181c32;\n        margin-bottom: 16px;\n      }\n\n      .section-content {\n        font-size: 14px;\n        color: #5e6278;\n        line-height: 1.6;\n        margin: 0;\n      }\n\n      .info-grid {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 16px;\n\n        @media (max-width: 768px) {\n          grid-template-columns: 1fr;\n        }\n\n        .info-item {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n\n          .info-label {\n            font-size: 13px;\n            font-weight: 600;\n            color: #7e8299;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n          }\n\n          .info-value {\n            font-size: 14px;\n            color: #181c32;\n            font-weight: 500;\n          }\n\n          .status-badge {\n            display: inline-block;\n            padding: 6px 12px;\n            border-radius: 20px;\n            font-size: 12px;\n            font-weight: 600;\n            text-transform: uppercase;\n            width: fit-content;\n\n            &.status-completed {\n              background-color: #50cd89;\n              color: #fff;\n            }\n\n            &.status-in-progress {\n              background-color: #ffc700;\n              color: #fff;\n            }\n\n            &.status-planned {\n              background-color: #009ef7;\n              color: #fff;\n            }\n\n            &.status-archived {\n              background-color: #a1a5b7;\n              color: #fff;\n            }\n\n            &.status-default {\n              background-color: #f1f1f2;\n              color: #5e6278;\n            }\n          }\n        }\n      }\n\n      .features-list {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        .feature-item {\n          display: flex;\n          gap: 12px;\n          padding: 12px;\n          background-color: #f9f9f9;\n          border-radius: 8px;\n\n          .feature-number {\n            font-size: 14px;\n            font-weight: 600;\n            color: #181c32;\n            min-width: 24px;\n          }\n\n          .feature-content {\n            flex: 1;\n\n            .feature-name {\n              font-size: 14px;\n              font-weight: 600;\n              color: #181c32;\n              margin-bottom: 4px;\n            }\n\n            .feature-description {\n              font-size: 13px;\n              color: #5e6278;\n              line-height: 1.5;\n            }\n          }\n        }\n      }\n\n      .no-features {\n        font-size: 14px;\n        color: #7e8299;\n        font-style: italic;\n      }\n    }\n  }\n\n  .modal-footer {\n    border-top: 1px solid #e4e6ef;\n    padding: 16px 24px;\n    background-color: #f9f9f9;\n    border-radius: 0 0 12px 12px;\n    display: flex;\n    justify-content: flex-end;\n\n    .btn {\n      padding: 10px 20px;\n      border-radius: 6px;\n      font-weight: 500;\n      font-size: 14px;\n      border: none;\n      cursor: pointer;\n\n      &.btn-light {\n        background-color: #f1f1f2;\n        border-color: #f1f1f2;\n        color: #5e6278;\n\n        &:hover {\n          background-color: #e4e6ef;\n          border-color: #e4e6ef;\n        }\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
